import React, { useCallback, useState, useEffect } from 'react';
import moment from 'moment';
import { createExport, getAllExportJobs, getAllJobs } from '../../../services/private/csv.service';
import { toast } from 'react-toastify';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../Data-import/import.css';
import ExportFilterModal from '../../../components/Modals/ExportFilterModal';

const DataImport = () => {
    const [show, setShow] = useState(false);
    const [exportedLeads, setExportedLeads] = useState([])

    const closeModal = useCallback(() => {
        setShow(false);
    }, []);

    const handleFilter = useCallback(async (filter) => {
        createExport(filter).then((res) => {
            if (res.data.status === 200) {
                toast.success('Export in process');
                getExport();
            }
        })
            .catch((err) => {
                console.log({ err })
                toast.error(err.response?.data.message)
            })
        closeModal(false)
    }, [])

    const getExport = useCallback(async (filter) => {
        getAllExportJobs(filter).then((res) => {
            if (res.data.status === 200) {
                setExportedLeads(res.data.data)
            }
        })
            .catch((err) => {
                console.log({ err })
            })
    }, [])

    useEffect(() => {
        getExport();
    }, []);

    return (
        <div className="w-100 all-pr flex flex-col h-full">
            <div className="settings-title">
                <div className="row d-flex flex-fill">
                    <div className="col-md-8 col-sm-8 d-flex flex-fill flex-column">
                        <h1 className="fz28  mb-16 black fw-po-medium">Export</h1>
                        <p className='fz16 black-dark-700 mb-0 d-md-block d-none'>Export your Leads from Propacity Platform in CSV format.</p>
                        <p className='fz16 black-dark-700 mb-0 d-md-none '>Export your leads from Propacity Platform</p>
                    </div>
                    <div className="col-md-4 col-sm-4 justify-content-end d-flex align-items-end mt-sm-0 mt-3">

                        <button onClick={() => { setShow(true) }} className="pr-btn flex">
                            <svg className="mr4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="path-1-inside-1_1117_451" fill="white">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" />
                                </mask>
                                <path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white" />
                                <path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)" />
                            </svg>
                            New Export
                        </button>
                    </div>
                </div>
            </div>

            <div className="mt-24 ml-24 exprot-table-main h-full overflow-auto">
                <div className="def-table pr-24 import-leads-table !h-full">
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Exported Date</th>
                                <th>Lead Count</th>
                                <th>Exported by</th>
                                <th>Status</th>
                                <th>Download CSV</th>

                            </tr>
                        </thead>
                        <tbody>
                            {exportedLeads.length > 0 ? exportedLeads.map((lead, index) => {
                                return (
                                    <tr key={lead.id}>
                                        <td>{index + 1}</td>
                                        <td>{moment(lead.created_on).format("h:mm a, Do MMM YYYY")}</td>
                                        <td> {lead.total_leads}</td>
                                        <td>
                                            {lead.created_by.length > 20 ?

                                                <OverlayTrigger
                                                    placement="bottom"
                                                    overlay={
                                                        <Tooltip id="button-tooltip" >
                                                            <div className='info-msg'>
                                                                {/* <h4>Total Leads</h4> */}
                                                                <p className='text-capitalize'>{lead.created_by}</p>
                                                            </div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className='text-capitalize three-dots'>{lead.created_by}</span>
                                                </OverlayTrigger>
                                                :
                                                <span className='text-capitalize three-dots'>{lead.created_by}</span>
                                            }
                                        </td>
                                        {/* <th className='import-status'>{lead.status}</th> */}
                                        <td className='import-status'><span className={` text-capitalize ${lead.status === 'exported' ? 'green-color-btn' : 'orange-color-btn'} ${lead.status === 0 ? 'red-color-btn' : ''}`}>{lead.status}</span></td>
                                        <td>
                                            {lead.url ? <a href={lead.url} target='_blank' className='pr-hover outline-btn px-24 py-8'>Download</a> : <span className='ml-4'>-</span>}
                                        </td>

                                    </tr>
                                )
                            })
                                :
                                <><tr className='nohover'>
                                    <td colSpan={9}>
                                        <div className='d-flex justify-content-center flex-column text-center lead-pagination'>
                                            <figure className='self-center'><svg xmlns="http://www.w3.org/2000/svg" width="63" height="65" viewBox="0 0 63 65" fill="none"><circle cx="33.1727" cy="35.6068" r="29.3934" fill="#F0F6FF"></circle><path d="M39.6259 38.4741C39.1482 38.2353 30.7839 43.2533 30.545 44.2094C30.3062 45.1654 37.3318 58.8344 39.6259 63.8049C46.5082 62.2755 51.5744 58.229 53.2472 56.3969C53.2472 56.3969 40.2674 38.7946 39.6259 38.4741Z" fill="#0062FF"></path><circle opacity="0.1" cx="21.9407" cy="22.4632" r="20.0735" fill="#696974"></circle><circle cx="20.5071" cy="20.0735" r="20.0735" fill="#B5B5BE"></circle><circle cx="20.5078" cy="20.0732" r="16.25" fill="#D5D5DC"></circle><path fillRule="evenodd" clipRule="evenodd" d="M14.2217 35.0627C9.40488 32.2428 6.16973 27.0138 6.16973 21.0292C6.16973 12.0546 13.4451 4.77918 22.4197 4.77918C24.6483 4.77918 26.7722 5.22781 28.7058 6.03969C26.2992 4.63079 23.4978 3.82324 20.5078 3.82324C11.5332 3.82324 4.25781 11.0986 4.25781 20.0732C4.25781 26.8193 8.36853 32.6052 14.2217 35.0627Z" fill="#696974"></path><path d="M33.1716 35.3677L30.543 37.2794L33.1716 42.5368L36.7562 40.3861L33.1716 35.3677Z" fill="#B5B5BE"></path></svg></figure>
                                            <h2 className="po black fz16 fw-po-medium mb-8 text-capitalize"> No previous export recorded.</h2>
                                            <p className='text-center black-dark-600 fz14 mb-0 text-capitalize'>Click on the button below and start exporting your leads.</p>
                                            <div className='mt-2'>
                                                <button onClick={() => { setShow(true) }} className="pr-btn" style={{ width: '114px' }}>
                                                    Export Now
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </>
                            }
                        </tbody>
                    </table>

                </div>
            </div>
            {show &&
                <ExportFilterModal
                    show={show}
                    closeModal={closeModal}
                    filtersData={[]}
                    setFilterCount={() => { }}
                    handleFilter={handleFilter}
                />
            }
        </div>
    )
}

export default DataImport